var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn",class:_vm.type ? _vm.type : 'default'},[_c('van-icon',{staticClass:"icons",attrs:{"name":"arrow","color":"#fff"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }